import React from 'react';
import { useLocation } from 'react-router-dom';

const useCurrentUrl = (): string => {
  const location = useLocation();

  return React.useMemo(
    () => `${window.location.origin}${location.pathname}${location.search}${location.hash}`,
    [location.hash, location.pathname, location.search],
  );
};

export default useCurrentUrl;
